module.exports = "<div class=\"overlay hidden\"></div>\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./~/overlay-component/template.html
 ** module id = 13
 ** module chunks = 0
 **/